import { getLine } from '@core/core/helpers'
import type { CubeLinesForTabs, UpdateCubeLineValuePayload } from '@core/core/types'
import type { PayloadAction } from '@reduxjs/toolkit'
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'

export const cubeLineForTabAdapter = createEntityAdapter<CubeLinesForTabs>({
  selectId: cubeLine => cubeLine.tabId,
})

export const cubeLineForTabSlice = createSlice({
  name: 'cubeLinesForTabs',
  initialState: cubeLineForTabAdapter.getInitialState(),
  reducers: {
    createCubeLinesForTab(state, action: PayloadAction<CubeLinesForTabs>) {
      cubeLineForTabAdapter.addOne(state, action.payload)
    },
    addCubeLineForTab: (
      state,
      { payload: { tabId, cubeLines } }: PayloadAction<CubeLinesForTabs>,
    ) => {
      const entity = state.entities[tabId]
      entity?.cubeLines.push(...cubeLines)
    },
    updateLineValueForTab: (
      state,
      { payload: { tabId, cubeLineId, lineValue } }: PayloadAction<UpdateCubeLineValuePayload>,
    ) => {
      const entity = state.entities[tabId]
      const cubeLines = entity?.cubeLines
      if (cubeLines) {
        const cubeLine = getLine(cubeLines, cubeLineId)
        if (cubeLine) {
          cubeLine.value = lineValue
        }
      }
    },
  },
})

export default cubeLineForTabSlice.reducer
